
import React from "react";
import { PostSection } from "@/components/blog/PostSection";

export function HerramientasSection() {
  return (
    <PostSection id="herramientas-recursos" title="Herramientas y Recursos para el SEO Local">
      <p>
        Las herramientas y recursos para el SEO local incluyen herramientas esenciales como nuestra <a href="/agenda-consultoria" className="text-seo-bright hover:underline">Auditoría SEO Local</a> y el <a href="/agenda-consultoria" className="text-seo-bright hover:underline">Analizador de Encabezados</a>. También ofrecemos servicios profesionales de <a href="/servicios/seo-local-ia" className="text-seo-bright hover:underline">SEO Local con IA</a>.
      </p>
      <ul>
        <li>Herramientas de Google para SEO: Google My Business, Google Analytics, Google Search Console y herramientas de optimización de contenido.</li>
        <li>Aplicaciones y plataformas de análisis: Herramientas como SEMrush, Ahrefs y Moz para analizar el SEO y optimizar las estrategias.</li>
        <li>Formación y actualización constante: Mantenerse actualizado con las últimas tendencias y herramientas del SEO local.</li>
      </ul>
    </PostSection>
  );
}
